export default {
  root: {
    class: [
      'relative',
      'overflow-hidden',
      'w-full',
      'aspect-video',

      '[&>img]:w-full',
      '[&>img]:h-full',
      '[&>img]:absolute',

      '[&>img+img]:[clip-path:polygon(0_0,var(--p-imagecompare-scope-x,50%)_0,var(--p-imagecompare-scope-x,50%)_100%,0_100%)]',

      '[dir=rtl] [&>img+img]:[clip-path:polygon(var(--p-imagecompare-scope-x,50%)_0,100%_0,100%_100%,var(--p-imagecompare-scope-x,50%)_100%)]'
    ]
  },
  slider: {
    // style: {
    //   transform: 'translateX(calc(var(--p-imagecompare-scope-x,50%)/2))'
    // },
    class: [
      'relative',
      'appearance-none',
      'w-[calc(100%+1rem)]',
      'h-full',
      '-ms-2',
      'bg-transparent',
      'outline-none',
      'transition-all',
      'duration-200',
      'hover:w-[calc(100%+2rem)]',
      'hover:-ms-4',

      '[&::-webkit-slider-thumb]:appearance-none',
      '[&::-webkit-slider-thumb]:h-4',
      '[&::-webkit-slider-thumb]:w-4',
      '[&::-webkit-slider-thumb]:bg-white/30',
      '[&::-webkit-slider-thumb]:rounded-full',
      '[&::-webkit-slider-thumb]:bg-contain',
      '[&::-webkit-slider-thumb]:cursor-ew-resize',
      '[&::-webkit-slider-thumb]:transition-all',
      '[&::-webkit-slider-thumb]:duration-200',
      '[&::-webkit-slider-thumb]:focus-visible:outline',
      '[&::-webkit-slider-thumb]:focus-visible:outline-1',
      '[&::-webkit-slider-thumb]:focus-visible:outline-offset-2',
      '[&::-webkit-slider-thumb]:focus-visible:outline-primary',
      'hover:[&::-webkit-slider-thumb]:bg-white/40',
      'hover:[&::-webkit-slider-thumb]:h-8',
      'hover:[&::-webkit-slider-thumb]:w-8',

      '[&::-moz-range-thumb]:appearance-none',
      '[&::-moz-range-thumb]:h-4',
      '[&::-moz-range-thumb]:w-4',
      '[&::-moz-range-thumb]:bg-white/30',
      '[&::-moz-range-thumb]:rounded-full',
      '[&::-moz-range-thumb]:bg-contain',
      '[&::-moz-range-thumb]:cursor-ew-resize',
      '[&::-moz-range-thumb]:transition-all',
      '[&::-moz-range-thumb]:duration-200',
      '[&::-moz-range-thumb]:focus-visible:outline',
      '[&::-moz-range-thumb]:focus-visible:outline-1',
      '[&::-moz-range-thumb]:focus-visible:outline-offset-2',
      '[&::-moz-range-thumb]:focus-visible:outline-primary',
      'hover:[&::-moz-range-thumb]:bg-white/40',
      'hover:[&::-moz-range-thumb]:h-8',
      'hover:[&::-moz-range-thumb]:w-8'
    ]
  }
}
